import { Heading, Box, Img, Flex, Button } from '@chakra-ui/react';
import React from 'react';
import PARAGRAPH_MAPPING from '../../../config/paragraph-mapping';
import { PersonFragmentFragment } from '../../../generated/types';
import Container from '../../Layout/Container';
import Wrapper from '../Wrapper';
import PageHero from '../../Layout/PageHero';
import getIconForCategoryKey from '../../../utils/getIconForCategoryKey';
import parseISO from 'date-fns/parseISO';
import format from 'date-fns/format';

export interface PersonProps {
  data: PersonFragmentFragment;
}

const Person: React.FC<PersonProps> = ({ data }) => {
  console.log('pers', data);
  if (!data) {
    return null;
  }

  return (
    <Wrapper typename={data.__typename} activeCategory={null}>
      <Box className="NodePerson">
        <Container className="ContentWrapper">
          <Flex
            my={9}
            flexDir={{
              base: 'column',
              md: 'row',
            }}
          >
            <Box
              width={{
                base: '100%',
                md: '40%',
              }}
              mr={{
                base: 0,
                md: 6,
              }}
            >
              <Img
                width="100%"
                height="auto"
                src={data.teaserImage?.teaser?.url}
                borderRadius={{
                  base: 0,
                  md: 'lg',
                }}
              />
            </Box>
            <Box
              mt={{
                base: 4,
                md: 0,
              }}
            >
              <Box as="h1" fontSize="xl" fontWeight="bold">
                {data.title}
              </Box>
              {data.job && (
                <Box fontSize="sm" color="gray.700">
                  {data.job}
                </Box>
              )}

              <Box
                mt={4}
                __css={{
                  '&>div': {
                    my: 4,
                  },
                  '&>.ParagraphText > .ParagraphContainer': {
                    px: 0,
                  },
                }}
              >
                {data.personContent?.map((data) => {
                  if (PARAGRAPH_MAPPING[data.__typename]) {
                    const Component = PARAGRAPH_MAPPING[data.__typename];
                    return <Component key={data.id} data={data} />;
                  }

                  return null;
                })}
              </Box>
            </Box>
          </Flex>
        </Container>
      </Box>
    </Wrapper>
  );
};

export default Person;
